let commonFilter = {
  filters: {
    getplayWay: function(value) {
      let levelMap = new Map([
        [1, "自然风光"],
        [2, "玩乐"],
        [3, "名胜古迹"],
        [4, "休闲区"],
        [5, "人文探索"],
        [6, "健康养生"]
      ]);
      let res = "";
      if (value === "--") {
        return "--";
      } else {
        if (value.length === 1) {
          return levelMap.get(value[0].typeId)
        } else {
          value.forEach( (element,index) => {
            index === value.length-1 ? res +=levelMap.get(element.typeId): res += `${levelMap.get(element.typeId)}，`;
          });
        }
        return res;
      }
    },
    gettourPar: function(value) {
      let levelMap = new Map([
        [1, "独自一人"],
        [2, "好友"],
        [3, "亲子"],
        [4, "情侣"],
        [5, "闺蜜"],
        [6, "同学"],
        [7, "拼团"],
        [8, "家人"],
        ["--", "--"]
      ]);
      return levelMap.get(value);
    },
    getdifficulty: function(value) {
      let levelMap = new Map([[1, "轻松"], [2, "适中"], [3, "困难"], ["--", "--"],[undefined,'--']]);

      return levelMap.get(value);
    },
    formatTime(value) {
      if (value && value !== '--') {
        return value.substring(0, value.indexOf(" "));
      } else {
        return "--";
      }
    },
    formatDate(value) {
      if (value) {
        return value.split(" ")[0];
      }
      return "";
    }
  }
}
export { commonFilter }